import { apiFetch } from "./client";
import type { PromotionData } from "@/lib/promotion-types";

export async function fetchPromotions(scopeQuery = ""): Promise<PromotionData> {
  return apiFetch<PromotionData>(`/api/promotions${scopeQuery}`);
}
